import { padreTypes } from "../../types/padreTypes"
import { savePadre, validCodigoVerificacion } from "../actions/padreActions"
import { ProcesoStart, ProcesoEnd } from "../../controls/Proceso"
import { generateToken, validaDNI, getVeeduriaPadre } from "../../helpers/padreHelper"
import { Mensaje } from "../../controls/Mensaje"
import { logErrors, MessagesError } from "../../logErrors"


export const generate_Token = () => {
    return async() => {
        try {
            const response = await generateToken()

            if ( response.Success ) {
                localStorage.setItem('token', response.Data);
            }

        } catch ( e ) {
            const err = logErrors( e )
            Mensaje( err.Message, err.Type )
        }
        
    }
}




export const savePadreBD = ( padre ) => {
    return async( dispatch, getState ) => {
        try {
            const { dni } = getState().padre
            const { cargo } = getState().informacion_basica
debugger;
            if ( dni !== padre.dni )
            {
                // INICIO: Con captcha
                const { codigo } = getState().captcha

                if ( padre.codigo_verificacion.toLowerCase() !== codigo.toLowerCase() )
                {
                    dispatch( validCodigoVerificacion( { message: MessagesError.codigo_verificacion, severity: 'error' } ) )
                }
                else{

                    ProcesoStart()
                    dispatch( savePadre( padre ) )
                    
                    const response = await validaDNI( padre )

                    console.log('validaDNI::', response.Data)
                    if ( response.Validacion !== '' ){
                        dispatch( { type: padreTypes.PADRE_SAVE_ERROR, payload: { message: response.Validacion, severity: 'error' } } );
                    }
                    else{
            
                        if(cargo == '007') {
                            dispatch( { type: padreTypes.PADRE_SAVE_COMPLETE, 
                            payload: { ...response.Data, message: 'Se buscó con éxito', severity: 'success', id_veeduria: '0' } } );
                        }
                        else {
                            localStorage.removeItem('token');
                            localStorage.setItem('token', response.Data.token);
    
                            const responseVeeduria = await getVeeduriaPadre( padre )
    // console.log('xxxxxxxxxx:', informacion_basica.cargo)

                            if ( responseVeeduria.Validacion !== '' )
                                dispatch( { type: padreTypes.PADRE_SAVE_ERROR, payload: { message: response.Validacion, severity: 'error' } } );
                            else
                                dispatch( { type: padreTypes.PADRE_SAVE_COMPLETE, 
                                    payload: { ...response.Data, message: 'Se buscó con éxito', severity: 'success', id_veeduria: (responseVeeduria.Data == null ? '0' : responseVeeduria.Data.estudiante.id_veeduria) } } );    
                        }

                            
                    }

                    ProcesoEnd()

                }
                // FIN: Con captcha


                // // INICIO: Sin captcha
                // ProcesoStart()
                // dispatch( savePadre( padre ) )
                
                // const response = await validaDNI( padre )

                // if ( response.Validacion !== '' ){
                //     dispatch( { type: padreTypes.PADRE_SAVE_ERROR, payload: { message: response.Validacion, severity: 'error' } } );
                // }
                // else{
                //     localStorage.setItem('token', response.Data.token);
                //     dispatch( { type: padreTypes.PADRE_SAVE_COMPLETE, 
                //         payload: { ...response.Data, message: 'Se buscó con éxito', severity: 'success' } } );
                // }

                // ProcesoEnd()
                // // FIN: Sin captcha





            }
        } catch ( e ) {
            ProcesoEnd()
            dispatch( { type: padreTypes.PADRE_SAVE_ERROR, payload: [] } );
            const err = logErrors( e )
            Mensaje( err.Message, err.Type )
            
        }
        
    }
}